export default "assets/images/decoration-20331e9f.png";